import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    position: relative;

    color: ${theme.colors.neutralSilver80};

    .react-multi-email {
      font-size: 1.6rem;
      font-weight: 400;
      line-height: 2.6rem;
      padding: 5px 12px;
      border: 1px solid ${theme.colors.neutralSilver10};
      outline-color: ${theme.colors.neutralSilver10};
      border-radius: 4px;

      input {
        height: 34px;
      }

      &::placeholder {
        color: ${theme.colors.neutralSilver50};
        font-weight: 400;
      }

      &:hover {
        border: 1px solid ${theme.colors.purple50};
      }

      &:active,
      &:focus {
        border: 1px solid ${theme.colors.brandPrimary100};
        outline: 1px solid ${theme.colors.brandPrimary30};
        outline-offset: 1px;
      }

      & [data-tag] {
        background-color: ${theme.colors.brandPrimary10};
        font-size: 1.6rem;
        font-weight: 500;

        [data-tag-handle] {
          font-size: 1.8rem;
          font-weight: 700;
          color: ${theme.colors.brandPrimary40};
        }
      }
    }
  `}
`;

export const InvitingText = styled.p`
  ${({ theme }) => css`
    font-size: 1.4rem;
    line-height: 1.6;
    color: ${theme.colors.neutralSilver60};
    // position: absolute;
    margin-top: 12px;

    > strong {
      color: ${theme.colors.neutralSilver70};
    }

    @media (max-width: 576px) {
      position: relative;
    }
  `}
`;
